export default {
  getUserId: (state, getters) => {
    if (state.userId) {
      return state.userId
    } else {
      return null
    }
  },
  getMyInfo: (state, getters) => {
    if (state.myInfo && state.myInfo._id) {
      return state.myInfo
    } else {
      return null
    }
  },
  profileUpdateSchema: (state, getters) => {
    if (state.profileUpdateSchema) {
      return state.profileUpdateSchema
    } else {
      return null
    }
  },
  parentUserUpdateSchema: (state, getters) => {
    if (state.parentUserSchema) {
      return state.parentUserSchema
    } else {
      return null
    }
  },
  getClientInfo: (state, getters) => {
    return state.clientInfo
  },
  getClientId: (state, getters) => {
    return state.clientId
  }
}



// WEBPACK FOOTER //
// ./src/app/store/profile/getters.js